// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"a5d21306","228":"9a8d47dc","272":"8ec62dfe","287":"8f539e20","352":"030204c5","549":"754ac649","666":"b2c655b9","816":"09622566","837":"5bbd345c","930":"2dadf3ab"}[chunkId] + ".chunk.js";
};